<!-- <template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div class="d-flex-column justify-start align-start gap-5">
      <h5 class="title-h5 t-white font-family-1">
        {{ $t("new.server") }}
      </h5>
      <p class="regular-l t-light font-family-2">
        {{ $t("new.select_server") }}
      </p>
    </div>
    <div class="d-flex-row space-between md-row-to-col">
      <div
        class="game_server_selector b-radius-9 d-flex-row space-between"
        :key="server.id"
        v-for="server in getGamePack.servers"
        role="button"
        @click.stop="() => selectServer(server)"
        :class="[checkoutStore.getSelectedServer?.value == server.id && 'active']"
      >
        <div class="d-flex-row flex-3 justify-start">
          <img
            :src="`/images/icons/${server?.title?.toLowerCase()}.webp`"
            class="server_icon"
            alt="server_icon"
            height="66"
            width="99"
          />
        </div>
        <label class="flex-7 t-white regular-xxxl font-family-2 f-w-500">{{
          server?.title
        }}</label>

        <Switch
          :click-param="server"
          :checked="checkoutStore.getSelectedServer?.value == server.id"
          :click-events="switchClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Switch from "../../../custom/Switch.vue";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    // ...mapGetters(["getGamePack", "getSelectedServer"]),
  },
  components: {
    Switch,
  },

  methods: {
    selectServer(server) {
      if (this.checkoutStore.getSelectedServer?.value === server.id) {
        // this.$store.commit("setServer", null);
        this.checkoutStore.setServer(null);
        return;
      }
      if (server.id) {
        this.checkoutStore.setServer(server.id);
      }
    },
    switchClick(option) {
      // this.selectOption(option);
    },
  },
  setup() {
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGamePack,
      checkoutStore,
    };
  },
};
</script> -->

<template>
  <RaidServerPicker
    :selected-servers="[checkoutStore.getSelectedServer?.value]"
    @select-server="selectServer"
    class="server_picker_raid"
  />
</template>

<script setup>
import RaidServerPicker from "~/components/raid-calendar/RaidServerPicker.vue";
const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();

const selectServer = (serverId) => {
  checkoutStore.setServer(serverId);
};
</script>
